// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"1499d896","676":"7498cfce","704":"95e8bbfc","808":"ec3f365c"}[chunkId] + ".chunk.css";
};